import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Radio,
  FormControlLabel,
} from "@mui/material";
import "./PujaSubscriptionCard.scss";
import ShowMoreShowLess from "../ShowMoreShowLess/ShowMoreShowLess";
import { LOCALIZATION } from "../../utils/localization";
import { t } from "i18next";
import ImageView from "../ImageView/ImageView";

interface PujaSubscriptionCardProps {
  id: string;
  name: string;
  duration: string;
  type: string;
  description: string;
  finalPrice: number;
  offerActualPrice?: number;
  currencySymbol?: string;
  onSelect: (id: string) => void;
  selected: boolean;
  subscriptionImage: any;
  isOnlySubscriptionEnable?:any;
}

const PujaSubscriptionCard: React.FC<PujaSubscriptionCardProps> = (props:any) => {
  const {id,
  name,
  duration,
  type,
  description,
  finalPrice,
  offerActualPrice,
  currencySymbol = "₹",
  onSelect,
  selected,
  subscriptionImage,
  isOnlySubscriptionEnable = false
} = props;
  return (
    <Card
      className={`pujaSubscriptionCard ${selected ? "selected" : ""}`}
      sx={{ mb: 1, pb: 0 }}
    >
      <CardContent className="subscriptionCardContent">
        <Box display="flex" alignItems="center">
          <FormControlLabel
            control={
              <Radio
                checked={selected}
                
                onClick={() => {
                  if(isOnlySubscriptionEnable){
                    return;
                  }
                  if (selected) {
                    onSelect("");
                  } else {
                    onSelect(id);
                  }
                }}
                color="primary"
              />
            }
            label={t("Subscribe_and_Save")}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontWeight: 550,
                fontSize: "1rem",
                marginBottom: 0,
              },
            }}
          />
        </Box>

        <Box className="headerSection">
          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography variant="h4" className="price">
                {currencySymbol} {finalPrice}
              </Typography>

              {Number(offerActualPrice) > 0 && (
                <Typography
                  variant="body2"
                  sx={{ textDecoration: "line-through", color: "gray" }}
                >
                  {currencySymbol} {offerActualPrice}
                </Typography>
              )}
            </Box>
            <Typography variant="h5" className="monthlyPlan">
              {name} ({duration} {type})
            </Typography>
          </Box>

          <Box className="subscriptionImageBox">
            <ImageView src={subscriptionImage} alt={name} />
          </Box>
        </Box>
        <Box className="planDetailsSection" sx={{ mt: 1 }}>
          <Typography variant="h6" className="planDetailsTitle">
            {t(LOCALIZATION.Plan_Details)}
          </Typography>
          <ul className="detailsList">
            <li className="detailItem">
              <Box className="bottomDescription" sx={{ mt: -1 }}>
                <ShowMoreShowLess 
                text={description} 
                mode="line"
                lines={2}
                // limit={120} 
                />
              </Box>
            </li>
          </ul>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PujaSubscriptionCard;
